/** @format */

import React, { useEffect, useState } from 'react'
import { getData } from '../../../../../../../Helpers/webApi'
import localize from '../../../../../../../Global/Localize'
import { formatDate } from '../../../../../../../Helpers/formatters'
import Tab from '../../../../../../../Components/Tabs/Tab'
import { ViewRequisitionEntries } from './ViewRequisitionEntries'
import Loader from '../../../../../../../Components/Loaders/Loader'

export const ApproveRequisitionModal = ({ selectedRequisition, isBusy }) => {
  const [reqParams, setReqParams] = useState({
    requisitionId: selectedRequisition?.requisitionId,
    text: '',
    pageIndex: 0,
    pageSize: 10,
  })
  const [quotationEntries, setQuotationEntries] = useState([])
  const fetchRequisitionItems = async () => {
    const { success, data } = await getData(
      '/Requisition/find-requisitions-items-by-requisition-id-filter-in-page',
      {
        ...reqParams,
        requisitionId: selectedRequisition?.requisition?.id,
      },
      false,
    )
    if (success) {
      setQuotationEntries(data)
    }
  }

  useEffect(() => {
    fetchRequisitionItems()
  }, [selectedRequisition?.requisition?.id])

  return (
    <>
      {isBusy ? (
        <Loader />
      ) : (
        <>
          <div className="row mb-3">
            <div className="col d-flex align-items-center">
              <label className="col-2 text-capitalize">
                {localize('department')}
              </label>
              <input
                value={selectedRequisition?.requisition?.departmentDescription}
                disabled
                className={'form-control'}
              />
            </div>
            <div className="col d-flex align-items-center">
              <label className="col-3 text-capitalize">
                {localize('expectedDate')}
              </label>
              <input
                className="form-control"
                disabled
                value={formatDate(
                  selectedRequisition?.requisition?.expectedDate,
                  true,
                )}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col d-flex align-items-center">
              <label className="col-2 text-capitalize">
                {localize('reason')}
              </label>
              <input
                className="form-control"
                value={selectedRequisition?.requisition?.reason}
                disabled
              />
            </div>
            <div className="col d-flex align-items-center">
              <label className="col-3 text-capitalize">
                {localize('branch')}
              </label>
              <input
                className="form-control"
                disabled
                value={selectedRequisition?.requisition?.branchDescription}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col d-flex align-items-center">
              <label className="col-2 text-capitalize">
                {localize('createdBy')}
              </label>
              <input
                className="form-control"
                value={selectedRequisition?.requisition?.createdBy}
                disabled
              />
            </div>
            <div className="col d-flex align-items-center">
              <label className="col-3 text-capitalize">
                {localize('createdDate')}
              </label>
              <input
                disabled
                className="form-control"
                value={formatDate(
                  selectedRequisition?.requisition?.createdDate,
                )}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              <div
                className="p-2 mt-4"
                style={{
                  border: 'solid 1px #0000001f',
                  borderRadius: 10,
                  position: 'relative',
                }}
              >
                <Tab
                  tabItems={[
                    {
                      label: localize('requisitionItems'),
                      item: (
                        <ViewRequisitionEntries
                          entries={quotationEntries}
                          setReqParams={setReqParams}
                          reqParams={reqParams}
                        />
                      ),
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}
